export default {
  name: 'Article list section - 11',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Category listing section',
    introtext: '',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 2","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 3","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"},{"button-style":"default","button-background-color":"var(--background-color)","button-text-color":"inherit","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-title":"Article 4"}]'
  },
  design: {
    'background-color': 'var(--secondary-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'var(--text-light-color)',
    'article-title-color': 'var(--text-light-color)',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h6',
    'article-introtext-color': 'var(--text-light-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'center',
    'article-columns': '4',
    'content-box': '0',
    'content-box-wrap': 'item',
    'content-box-color': 'black',
    'content-box-padding': '10px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
